import React, { Component } from 'react';
import { MenuItems } from './MenuItems';
import { Link as RouterLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

class Navbar extends Component {
  state = {
    clicked: false
  };

  handleClick = () => {
    this.setState({ clicked: !this.state.clicked });
  };

  closeMobileMenu = () => {
    this.setState({ clicked: false });
  };

  renderMenuItem = (item, index) => {
    if (item.type === 'external') {
      return (
        <li key={index}>
          <a
            href={item.url}
            className={item.cName}
            onClick={this.closeMobileMenu}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.itemName === 'Academy' ? (
              <span className="academy-btn-wrap">
                <span className="academy-btn-text">Academy</span>
                <span className="academy-orbit">
                  <i className="fas fa-graduation-cap academy-orbit-icon"></i>
                </span>
              </span>
            ) : (
              item.itemName
            )}
          </a>
        </li>
      );
    }

    if (item.type === 'route') {
      return (
        <li key={index}>
          <RouterLink
            to={item.path}
            className={item.cName}
            onClick={this.closeMobileMenu}
          >
            {item.itemName}
          </RouterLink>
        </li>
      );
    }

    if (item.type === 'hash') {
      return (
        <li key={index}>
          <HashLink
            smooth
            to={item.path}
            className={item.cName}
            onClick={this.closeMobileMenu}
          >
            {item.itemName}
          </HashLink>
        </li>
      );
    }

    return null;
  };

  render() {
    return (
      <>
        <nav className="navbar navbar-expand-lg sticky-top top-0">
          <div className="container">
            <HashLink
              smooth
              className="navbar-brand"
              to="/#home"
              onClick={this.closeMobileMenu}
            >
              <img
                src="img/logo.png"
                className="logo-img"
                alt="Simba Solution Logo"
              />
            </HashLink>

            <div className="menu-icon" onClick={this.handleClick}>
              <i className={this.state.clicked ? 'fas fa-times' : 'fas fa-bars'}></i>
            </div>

            <div>
              <ul className={this.state.clicked ? 'navbar-nav active' : 'navbar-nav'}>
                {MenuItems.map((item, index) => this.renderMenuItem(item, index))}
              </ul>
            </div>
          </div>
        </nav>
      </>
    );
  }
}

export default Navbar;
